import React from 'react'

export default function ContactHogyVagyMostContent() {
  return (
    <>
      <div className="space-y-6 p-6 text-lg">
        <div className="space-y-4">
          <p className="text-2xl font-bold italic text-amber-700">
            Lelki forrásaink művészetterápiás fesztivál program
          </p>
          
          <h3 className="text-3xl font-bold text-amber-800">Hogy vagy most?</h3>
          <p className="text-lg font-semibold text-amber-700">
            Télutó, tavaszváró művészetterápiás workshop
          </p>
          
          <div className="space-y-3">

          <div className="flex items-start gap-4 mb-12">
              <img 
                src="/images/question-sign.svg" 
                alt="Program" 
                className="w-16 h-16 flex-shrink-0 mt-1"
              />
            <div className="text-justify">
              <p>Február a csendes készülődés ideje. Még nem látszik semmi, mégis történik valami. A természetben is sokszor rejtve marad a változás, csak itt-ott bukkan elő egy-egy virág.
              Ilyenkor bennünk is keveredik a fáradtság, a türelmetlenség és a már elég volt érzése azzal a halvány reménnyel és a vággyal, hogy valami új kezdődik.
              <br/>A workshop során kollázs technikával nézzük meg, hol tartasz most ebben az átmenetben, a tél utolsó és a tavasz első pillanatai között.
              </p>
              <p className="text-justify font-mediu mt-4">
              Az alkalom nem a teljesítésről szól, hanem a belső figyelemről, a türelemről és arról a bizalomról, ami a változáshoz vezethet.
            </p>
              </div>
              
          </div>
            
  
          
          </div>
        </div>

        <div className="space-y-4">
          <div className="space-y-2">
            <p className="font-semibold">
              <i className="bi bi-house-door-fill mr-2"></i> Helyszín:
            </p>
            <p>MMSZKE Batyi, kisterem</p>
            <p></p>
          </div>

          <div className="space-y-2">
            <p className="flex items-center font-semibold">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-calendar mr-2 h-5 w-5">
                <path d="M8 2v4"></path>
                <path d="M16 2v4"></path>
                <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                <path d="M3 10h18"></path>
              </svg>
              Időpont:
            </p>
            <p>2026. február 22., szombat, 18:00 - 21:00</p>
            <p className="text-sm italic">Időtartam: max. 3 óra</p>
          </div>

          <div className="space-y-2">
            <p className="font-semibold">Létszám:</p>
            <p>minimum 4, maximum 8 fő</p>
          </div>

         
        </div>
      </div>
    </>
  )
}

